import { ChatCircleDotsIcon } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'

export interface AskCraftFloatingButtonProps {
  onClick: () => void
}

/**
 * Global floating entry to open Craft chat — same affordance site-wide (including Studio).
 */
export function AskCraftFloatingButton({ onClick }: AskCraftFloatingButtonProps) {
  return (
    <Button
      variant='unstyled'
      className='group fixed bottom-6 right-6 z-50 flex size-[67px] items-center justify-center rounded-full bg-neutral-950 shadow-[0_7px_14.5px_rgba(100,100,111,0.2)] transition-colors hover:bg-neutral-800'
      onClick={onClick}
      aria-label='Ask Craft'
    >
      <div className='relative flex size-full items-center justify-center'>
        <ChatCircleDotsIcon
          className='absolute top-[13px] size-6 text-white transition-transform group-hover:animate-chat-bounce'
          weight='fill'
        />
        <svg
          className='absolute inset-0 size-full transition-transform duration-500 ease-in-out group-hover:rotate-[15deg]'
          viewBox='0 0 67 67'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          aria-hidden='true'
          style={{ transformOrigin: 'center center' }}
        >
          <defs>
            <path id='chatTextPath' d='M 12 50 A 25 25 0 0 0 55 50' fill='none' />
          </defs>
          <text
            fill='white'
            fontSize='10'
            fontFamily='Circular Std, sans-serif'
            fontWeight='400'
            letterSpacing='0.1'
          >
            <textPath href='#chatTextPath' startOffset='50%' textAnchor='middle'>
              Ask Craft
            </textPath>
          </text>
        </svg>
      </div>
    </Button>
  )
}
